module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp1_7042.087073fc.png";